/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Error_Taxpayer_Id_FormatInputs */

const es_co2_signup_error_taxpayer_id_format = /** @type {(inputs: Signup_Error_Taxpayer_Id_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El NIT debe tener entre 5 y 10 dígitos.`)
};

/**

* @param {Signup_Error_Taxpayer_Id_FormatInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_error_taxpayer_id_format = /** @type {((inputs?: Signup_Error_Taxpayer_Id_FormatInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Error_Taxpayer_Id_FormatInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_error_taxpayer_id_format(inputs)
});